import { render, staticRenderFns } from "./internalCompany.vue?vue&type=template&id=6b4c9091&"
import script from "./internalCompany.vue?vue&type=script&lang=js&"
export * from "./internalCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports